import type { Mode } from '@/types'

type ApiTypes = 'auth' | 'apps' | 'orchestrator' | 'ws'

const API_LINKS: Record<ApiTypes, string> = {
    auth: 'https://auth{modeInfix}.transactionlink.io/auth/',
    apps: 'https://marketplace{modeInfix}.transactionlink.io/apps/',
    orchestrator: 'https://marketplace{modeInfix}.transactionlink.io/external-widget/',
    ws: 'wss://widget-ws{modeInfix}.transactionlink.io',
}

export function getApiLink(type: ApiTypes, mode: Mode) {
    const isProduction = mode === 'production'
    const modeInfix = isProduction ? '' : `.${mode}`
    const apiLink = API_LINKS[type].replace('{modeInfix}', modeInfix)

    return apiLink
}
